<template>
  <BBtn
    v-if="iconButton"
    class="copy-icon"
    size="small"
    fab
    flat
    @click="handleCopyClick"
  >
    <BIcon>
      {{ icon }}
    </BIcon>
  </BBtn>
  <BBtn
    v-else
    class="copy-button"
    type="default"
    size="mini"
    outline
    @click="handleCopyClick"
  >
    <BIcon
      size="mini"
    >
      {{ icon }}
    </BIcon>
    {{ buttonName }}
  </BBtn>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { KEY_OF_TOAST } from '@/injection-keys';

type TProps = {
  text: string;
  title: string;
  isDetailedName?: boolean;
  iconButton?: boolean;
  icon?: string;
};
const props = withDefaults(defineProps<TProps>(), {
  isDetailedName: false,
  icon: 'content_copy',
});
const toast = inject(KEY_OF_TOAST);
const i18n = useI18n();

const buttonName = computed(() => props.isDetailedName ? i18n.t('general.copyAction.of', { item: props.title }) : i18n.t('general.copyAction.text'));

const handleCopyClick = async () => {
  await navigator.clipboard.writeText(props.text);
  toast.show({
    message: i18n.t('general.copyAction.done', { item: props.title }),
    type: 'success',
  });
};
</script>

<style lang="scss" scoped>
.copy-button, .copy-icon {
  margin-left: auto;
  padding-left: $basespace-200;
  padding-right: $basespace-200;
}
.copy-button .b-icon {
  margin-right: $basespace-50;
}
</style>
